/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  FacadeFightLib,
  FacadeFightLibInterface,
} from "../FacadeFightLib";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "atype",
        type: "uint256",
      },
    ],
    name: "NotAType",
    type: "error",
  },
  {
    inputs: [],
    name: "NotMagic",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "daily",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "weekly",
        type: "bool",
      },
    ],
    name: "ActivityCompleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "week",
        type: "uint32",
      },
    ],
    name: "AddBiomeRequest",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "finalBalanceGamePoints",
        type: "uint256",
      },
    ],
    name: "AddGamePoints",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint48",
        name: "fightId",
        type: "uint48",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "items",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "itemIds",
        type: "uint256[]",
      },
    ],
    name: "AddPvpFightItems",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newUser",
        type: "address",
      },
    ],
    name: "AddToGuild",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "dungId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "address",
        name: "itemAdr",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
    ],
    name: "AddTreasuryItem",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "dungId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "AddTreasuryToken",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "week",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "merkleRoot_",
        type: "bytes32",
      },
    ],
    name: "AirdropDistributorAddTree",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256[]",
        name: "_weeks",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "AirdropDistributorClaim",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "week",
        type: "uint256",
      },
    ],
    name: "AirdropDistributorRemoveTree",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "AirdropDistributorSetToken",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "bidId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "msgSender",
        type: "address",
      },
    ],
    name: "ApplyAuctionBid",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "dungeon",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "AssetsSentToDungeon",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "bidId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "positionId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "msgSender",
        type: "address",
      },
    ],
    name: "AuctionBidOpened",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "positionId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "msgSender",
        type: "address",
      },
    ],
    name: "AuctionPositionClosed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "positionId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shelterId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sellerGuildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "msgSender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "minAuctionPrice",
        type: "uint256",
      },
    ],
    name: "AuctionPositionOpened",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256",
      },
    ],
    name: "AuctionSetFee",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "consumedItemId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "augLevel",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "uint8[]",
            name: "attributesIds",
            type: "uint8[]",
          },
          {
            internalType: "int32[]",
            name: "attributesValues",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "enum IItemController.AttackType",
                name: "aType",
                type: "uint8",
              },
              {
                internalType: "int32",
                name: "min",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "max",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "int32",
                    name: "strength",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "dexterity",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "vitality",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "energy",
                    type: "int32",
                  },
                ],
                internalType: "struct IStatController.CoreAttributes",
                name: "attributeFactors",
                type: "tuple",
              },
            ],
            internalType: "struct IItemController.AttackInfo",
            name: "attackInfo",
            type: "tuple",
          },
          {
            internalType: "uint8[]",
            name: "casterIds",
            type: "uint8[]",
          },
          {
            internalType: "int32[]",
            name: "casterValues",
            type: "int32[]",
          },
          {
            internalType: "uint8[]",
            name: "targetIds",
            type: "uint8[]",
          },
          {
            internalType: "int32[]",
            name: "targetValues",
            type: "int32[]",
          },
        ],
        indexed: false,
        internalType: "struct IItemController.AugmentInfo",
        name: "info",
        type: "tuple",
      },
    ],
    name: "Augmented",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldValue",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newValue",
        type: "uint256",
      },
    ],
    name: "BaseAmountChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "uri",
        type: "string",
      },
    ],
    name: "BaseUriChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
    ],
    name: "BiomeChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "msgSender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "taxPercent",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "taxAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
    ],
    name: "BiomeTaxPaid",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "msgSender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "taxPercent",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
    ],
    name: "BiomeTaxPaidNft",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "add",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "temporally",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "BonusAttributesChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "objectId",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "biome",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
    ],
    name: "BossCompleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "newNgLevel",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "reborn",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "rewardAmount",
        type: "uint256",
      },
    ],
    name: "BossKilled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "guidlId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shelterId",
        type: "uint256",
      },
    ],
    name: "BuyShelter",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "rights",
        type: "uint256",
      },
    ],
    name: "ChangeGuildRights",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "value",
        type: "bool",
      },
    ],
    name: "ChangePauseStatus",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "shelterId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fromGuildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "toGuildId",
        type: "uint256",
      },
    ],
    name: "ChangeShelterOwner",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "dungId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "ClaimItem",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "dungId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "ClaimToken",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Claimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "ClaimedItem",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "ClaimedToken",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "dungId",
        type: "uint64",
      },
    ],
    name: "Clear",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "msgSender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "configId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "items",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[][]",
        name: "itemIds",
        type: "uint256[][]",
      },
      {
        indexed: false,
        internalType: "address",
        name: "mintedItem",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "mintedItemId",
        type: "uint256",
      },
    ],
    name: "CombineItems",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
    ],
    name: "ConsumableUsed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint32",
            name: "level",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "experience",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "life",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "mana",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "lifeChances",
            type: "uint32",
          },
        ],
        indexed: false,
        internalType: "struct IStatController.ChangeableStats",
        name: "change",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "increase",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "CurrentStatsChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
    ],
    name: "DestroyItemInSandbox",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
    ],
    name: "Destroyed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "dungLogicNum",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "dungId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
    ],
    name: "DungeonCompleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "value",
        type: "address",
      },
    ],
    name: "DungeonFactoryChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "dungeonLogicNum",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "treasuryToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "treasuryAmount",
        type: "uint256",
      },
    ],
    name: "DungeonLaunched",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "dungLogicId",
        type: "uint16",
      },
      {
        components: [
          {
            internalType: "uint8[][]",
            name: "objTypesByStages",
            type: "uint8[][]",
          },
          {
            internalType: "uint32[][]",
            name: "objChancesByStages",
            type: "uint32[][]",
          },
          {
            internalType: "uint32[]",
            name: "uniqObjects",
            type: "uint32[]",
          },
          {
            internalType: "uint8",
            name: "minLevel",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "maxLevel",
            type: "uint8",
          },
          {
            internalType: "bytes32[]",
            name: "requiredCustomDataIndex",
            type: "bytes32[]",
          },
          {
            internalType: "uint64[]",
            name: "requiredCustomDataMinValue",
            type: "uint64[]",
          },
          {
            internalType: "uint64[]",
            name: "requiredCustomDataMaxValue",
            type: "uint64[]",
          },
          {
            internalType: "bool[]",
            name: "requiredCustomDataIsHero",
            type: "bool[]",
          },
        ],
        indexed: false,
        internalType: "struct IDungeonFactory.DungeonGenerateInfo",
        name: "info",
        type: "tuple",
      },
    ],
    name: "DungeonLogicRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "dungLogicId",
        type: "uint16",
      },
    ],
    name: "DungeonLogicRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "dungLogicId",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
    ],
    name: "DungeonRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "dungLogicId",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
    ],
    name: "DungeonRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "dungLogicId",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "biome",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroCls",
        type: "uint256",
      },
    ],
    name: "DungeonSpecificLogicRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint16",
        name: "dungLogicId",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroLvl",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroCls",
        type: "uint256",
      },
    ],
    name: "DungeonSpecificLogicRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "dungId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "Entered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "itemSlot",
        type: "uint8",
      },
    ],
    name: "Equipped",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "objectId",
        type: "uint32",
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "biome",
            type: "uint8",
          },
          {
            internalType: "uint16",
            name: "eventId",
            type: "uint16",
          },
          {
            internalType: "enum IGOC.ObjectSubType",
            name: "subType",
            type: "uint8",
          },
          {
            internalType: "uint32",
            name: "goodChance",
            type: "uint32",
          },
          {
            components: [
              {
                internalType: "uint8[]",
                name: "ids",
                type: "uint8[]",
              },
              {
                internalType: "int32[]",
                name: "values",
                type: "int32[]",
              },
            ],
            internalType: "struct IGOC.AttributeGenerateInfo",
            name: "goodAttributes",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint8[]",
                name: "ids",
                type: "uint8[]",
              },
              {
                internalType: "int32[]",
                name: "values",
                type: "int32[]",
              },
            ],
            internalType: "struct IGOC.AttributeGenerateInfo",
            name: "badAttributes",
            type: "tuple",
          },
          {
            internalType: "uint32",
            name: "experience",
            type: "uint32",
          },
          {
            internalType: "int32",
            name: "heal",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaRegen",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "lifeChancesRecovered",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damage",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaConsumed",
            type: "int32",
          },
          {
            internalType: "address[]",
            name: "mintItems",
            type: "address[]",
          },
          {
            internalType: "uint32[]",
            name: "mintItemsChances",
            type: "uint32[]",
          },
        ],
        indexed: false,
        internalType: "struct IGOC.EventRegInfo",
        name: "eventRegInfo",
        type: "tuple",
      },
    ],
    name: "EventRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "stageId",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "int32[]",
            name: "posAttributes",
            type: "int32[]",
          },
          {
            internalType: "int32[]",
            name: "negAttributes",
            type: "int32[]",
          },
          {
            internalType: "uint32",
            name: "experience",
            type: "uint32",
          },
          {
            internalType: "int32",
            name: "heal",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaRegen",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "lifeChancesRecovered",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damage",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaConsumed",
            type: "int32",
          },
          {
            internalType: "address[]",
            name: "mintedItems",
            type: "address[]",
          },
        ],
        indexed: false,
        internalType: "struct IStatController.ActionInternalInfo",
        name: "gen",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "iteration",
        type: "uint256",
      },
    ],
    name: "EventResult",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "dungId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "claim",
        type: "bool",
      },
    ],
    name: "Exit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "dungId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
    ],
    name: "ExitForcibly",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
    ],
    name: "ExitFromDungeon",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "consumedItemId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "itemDurability",
        type: "uint16",
      },
    ],
    name: "FailedToRepairItem",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "heroOwner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "openedNgLevel",
        type: "uint8",
      },
    ],
    name: "FameHallHeroRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        components: [
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterA",
            type: "tuple",
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterB",
            type: "tuple",
          },
        ],
        indexed: false,
        internalType: "struct IFightCalculator.FightInfoInternal",
        name: "result",
        type: "tuple",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "int32[]",
                name: "fighterAttributes",
                type: "int32[]",
              },
              {
                components: [
                  {
                    internalType: "uint32",
                    name: "level",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "experience",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "life",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "mana",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "lifeChances",
                    type: "uint32",
                  },
                ],
                internalType: "struct IStatController.ChangeableStats",
                name: "fighterStats",
                type: "tuple",
              },
              {
                internalType: "enum IFightCalculator.AttackType",
                name: "attackType",
                type: "uint8",
              },
              {
                internalType: "address",
                name: "attackToken",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "attackTokenId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "race",
                type: "uint256",
              },
            ],
            internalType: "struct IFightCalculator.FighterInfo",
            name: "fighterA",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "int32[]",
                name: "fighterAttributes",
                type: "int32[]",
              },
              {
                components: [
                  {
                    internalType: "uint32",
                    name: "level",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "experience",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "life",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "mana",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "lifeChances",
                    type: "uint32",
                  },
                ],
                internalType: "struct IStatController.ChangeableStats",
                name: "fighterStats",
                type: "tuple",
              },
              {
                internalType: "enum IFightCalculator.AttackType",
                name: "attackType",
                type: "uint8",
              },
              {
                internalType: "address",
                name: "attackToken",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "attackTokenId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "race",
                type: "uint256",
              },
            ],
            internalType: "struct IFightCalculator.FighterInfo",
            name: "fighterB",
            type: "tuple",
          },
          {
            internalType: "uint64",
            name: "dungeonId",
            type: "uint64",
          },
          {
            internalType: "uint32",
            name: "objectId",
            type: "uint32",
          },
          {
            internalType: "address",
            name: "heroAdr",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "heroId",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "stageId",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "iteration",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "turn",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct IFightCalculator.FightCall",
        name: "callData",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "iteration",
        type: "uint256",
      },
    ],
    name: "FightResultProcessed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "week",
        type: "uint32",
      },
    ],
    name: "FirstPvpEpoch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "consumedItem",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "consumedItemId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fragility",
        type: "uint256",
      },
    ],
    name: "FragilityReduced",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
    ],
    name: "FreeDungeonAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
    ],
    name: "FreeDungeonRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
    ],
    name: "FreeHeroCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "value",
        type: "address",
      },
    ],
    name: "GameObjectControllerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "value",
        type: "address",
      },
    ],
    name: "GameTokenChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "GameTokenPriceChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "index",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "GlobalCustomDataChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "gov",
        type: "address",
      },
    ],
    name: "GovernanceAccepted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "guildBank",
        type: "address",
      },
    ],
    name: "GuildBankDeployed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "GuildBankTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "nft",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "GuildBankTransferNft",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "nfts",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
    ],
    name: "GuildBankTransferNftMulti",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "value",
        type: "address",
      },
    ],
    name: "GuildControllerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "urlLogo",
        type: "string",
      },
    ],
    name: "GuildCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
    ],
    name: "GuildDeleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "newDescription",
        type: "string",
      },
    ],
    name: "GuildDescriptionChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "GuildHeroAsked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "GuildHeroReleased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
    ],
    name: "GuildHeroStaked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
    ],
    name: "GuildHeroWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "newLevel",
        type: "uint8",
      },
    ],
    name: "GuildLevelUp",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "newLogoUrl",
        type: "string",
      },
    ],
    name: "GuildLogoChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
    ],
    name: "GuildNftRewardRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "helpHeroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "helpHeroId",
        type: "uint256",
      },
    ],
    name: "GuildReinforcementAsked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "helperToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "helperId",
        type: "uint256",
      },
    ],
    name: "GuildReinforcementReleased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "newName",
        type: "string",
      },
    ],
    name: "GuildRename",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "msgSender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "userMessage",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "depositAmount",
        type: "uint256",
      },
    ],
    name: "GuildRequestRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "msgSender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "guildRequestId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "newStatus",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "GuildRequestStatusChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountAdded",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
    ],
    name: "GuildTokenRewardRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
    ],
    name: "HeroAsk",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "hitsLast24h",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "fixedFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "helperRewardAmount",
        type: "uint256",
      },
    ],
    name: "HeroAskV2",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
    ],
    name: "HeroBurned",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "value",
        type: "address",
      },
    ],
    name: "HeroControllerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "refCode",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "tier",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "ngLevel",
        type: "uint8",
      },
    ],
    name: "HeroCreatedNgp",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "refCode",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "tier",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "ngLevel",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "sandbox",
        type: "bool",
      },
    ],
    name: "HeroCreatedNgpSandbox",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
    ],
    name: "HeroCurrentDungeonChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "index",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "HeroCustomDataChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "index",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "ngLevel",
        type: "uint8",
      },
    ],
    name: "HeroCustomDataChangedNg",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "HeroCustomDataCleared",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemType",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemSlot",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "itemToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "equip",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "HeroItemSlotChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
    ],
    name: "HeroMinted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "heroClass",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "address",
        name: "payToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "payAmount",
        type: "uint256",
      },
    ],
    name: "HeroRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "biome",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "score",
        type: "uint256",
      },
    ],
    name: "HeroStaked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "biome",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "rewardAmount",
        type: "uint256",
      },
    ],
    name: "HeroStakedV2",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "uri",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "statusLvl",
        type: "uint256",
      },
    ],
    name: "HeroUriByStatusChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
    ],
    name: "HeroWithdraw",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "value",
        type: "address",
      },
    ],
    name: "ItemBoxControllerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "objectId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "nftToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "nftId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stageId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "iteration",
        type: "uint256",
      },
    ],
    name: "ItemBroken",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "objectId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "nftToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "nftId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stageId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "iteration",
        type: "uint256",
      },
    ],
    name: "ItemBurned",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ItemBurned",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "value",
        type: "address",
      },
    ],
    name: "ItemControllerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "helper",
        type: "address",
      },
    ],
    name: "ItemControllerHelper",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ItemMinted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "uint8",
                name: "itemMetaType",
                type: "uint8",
              },
              {
                internalType: "uint8",
                name: "itemLevel",
                type: "uint8",
              },
              {
                internalType: "enum IItemController.ItemType",
                name: "itemType",
                type: "uint8",
              },
              {
                internalType: "uint16",
                name: "baseDurability",
                type: "uint16",
              },
              {
                internalType: "uint8",
                name: "defaultRarity",
                type: "uint8",
              },
              {
                internalType: "uint32",
                name: "manaCost",
                type: "uint32",
              },
              {
                internalType: "uint8",
                name: "minRandomAttributes",
                type: "uint8",
              },
              {
                internalType: "uint8",
                name: "maxRandomAttributes",
                type: "uint8",
              },
              {
                components: [
                  {
                    internalType: "int32",
                    name: "strength",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "dexterity",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "vitality",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "energy",
                    type: "int32",
                  },
                ],
                internalType: "struct IStatController.CoreAttributes",
                name: "requirements",
                type: "tuple",
              },
            ],
            internalType: "struct IItemController.ItemMeta",
            name: "itemMeta",
            type: "tuple",
          },
          {
            internalType: "address",
            name: "augmentToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "augmentAmount",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint8[]",
                name: "ids",
                type: "uint8[]",
              },
              {
                internalType: "int32[]",
                name: "mins",
                type: "int32[]",
              },
              {
                internalType: "int32[]",
                name: "maxs",
                type: "int32[]",
              },
              {
                internalType: "uint32[]",
                name: "chances",
                type: "uint32[]",
              },
            ],
            internalType: "struct IItemController.ItemGenerateInfo",
            name: "commonAttributes",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint8[]",
                name: "ids",
                type: "uint8[]",
              },
              {
                internalType: "int32[]",
                name: "values",
                type: "int32[]",
              },
            ],
            internalType: "struct IGOC.AttributeGenerateInfo",
            name: "consumableAttributes",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "level",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "experience",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "life",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "mana",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "lifeChances",
                type: "uint32",
              },
            ],
            internalType: "struct IStatController.ChangeableStats",
            name: "consumableStats",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint8[]",
                name: "ids",
                type: "uint8[]",
              },
              {
                internalType: "int32[]",
                name: "mins",
                type: "int32[]",
              },
              {
                internalType: "int32[]",
                name: "maxs",
                type: "int32[]",
              },
              {
                internalType: "uint32[]",
                name: "chances",
                type: "uint32[]",
              },
            ],
            internalType: "struct IItemController.ItemGenerateInfo",
            name: "casterAttributes",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint8[]",
                name: "ids",
                type: "uint8[]",
              },
              {
                internalType: "int32[]",
                name: "mins",
                type: "int32[]",
              },
              {
                internalType: "int32[]",
                name: "maxs",
                type: "int32[]",
              },
              {
                internalType: "uint32[]",
                name: "chances",
                type: "uint32[]",
              },
            ],
            internalType: "struct IItemController.ItemGenerateInfo",
            name: "targetAttributes",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "enum IItemController.AttackType",
                name: "aType",
                type: "uint8",
              },
              {
                internalType: "int32",
                name: "min",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "max",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "int32",
                    name: "strength",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "dexterity",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "vitality",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "energy",
                    type: "int32",
                  },
                ],
                internalType: "struct IStatController.CoreAttributes",
                name: "attributeFactors",
                type: "tuple",
              },
            ],
            internalType: "struct IItemController.AttackInfo",
            name: "genAttackInfo",
            type: "tuple",
          },
          {
            internalType: "uint256",
            name: "consumableActionMask",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct IItemController.RegisterItemParams",
        name: "info",
        type: "tuple",
      },
    ],
    name: "ItemRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
    ],
    name: "ItemRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "consumedItemId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "baseDurability",
        type: "uint16",
      },
    ],
    name: "ItemRepaired",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
    ],
    name: "ItemReturnedToSandbox",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "killer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes32[]",
        name: "dropItems",
        type: "bytes32[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "dropTokenAmount",
        type: "uint256",
      },
    ],
    name: "Killed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "shelterId",
        type: "uint256",
      },
    ],
    name: "LeaveShelter",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroClass",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "int32",
            name: "strength",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "dexterity",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "vitality",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "energy",
            type: "int32",
          },
        ],
        indexed: false,
        internalType: "struct IStatController.CoreAttributes",
        name: "change",
        type: "tuple",
      },
    ],
    name: "LevelUp",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        components: [
          {
            internalType: "int32",
            name: "strength",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "dexterity",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "vitality",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "energy",
            type: "int32",
          },
        ],
        indexed: false,
        internalType: "struct IStatController.CoreAttributes",
        name: "change",
        type: "tuple",
      },
    ],
    name: "LevelUp",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "lootBoxKind",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "mintItems",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint32[]",
        name: "mintItemsChances",
        type: "uint32[]",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "maxDropItems",
        type: "uint256",
      },
    ],
    name: "LootBoxConfigChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "lootBoxKind",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "itemTokens",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "itemTokenIds",
        type: "uint256[]",
      },
    ],
    name: "LootBoxOpened",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "value",
        type: "uint8",
      },
    ],
    name: "MinLevelChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
    ],
    name: "MinLevelForTreasuryChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "MinLifeChancesChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "value",
        type: "address",
      },
    ],
    name: "MinterChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "objectId",
        type: "uint32",
      },
      {
        components: [
          {
            internalType: "uint16",
            name: "monsterId",
            type: "uint16",
          },
          {
            internalType: "uint8",
            name: "biome",
            type: "uint8",
          },
          {
            internalType: "enum IGOC.ObjectSubType",
            name: "subType",
            type: "uint8",
          },
          {
            internalType: "uint8[]",
            name: "attributeIds",
            type: "uint8[]",
          },
          {
            internalType: "int32[]",
            name: "attributeValues",
            type: "int32[]",
          },
          {
            internalType: "uint8",
            name: "level",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "race",
            type: "uint8",
          },
          {
            internalType: "uint32",
            name: "experience",
            type: "uint32",
          },
          {
            internalType: "uint8",
            name: "maxDropItems",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint64",
            name: "attackTokenId",
            type: "uint64",
          },
          {
            internalType: "uint8",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address[]",
            name: "mintItems",
            type: "address[]",
          },
          {
            internalType: "uint32[]",
            name: "mintItemsChances",
            type: "uint32[]",
          },
        ],
        indexed: false,
        internalType: "struct IGOC.MonsterGenInfo",
        name: "monsterGenInfo",
        type: "tuple",
      },
    ],
    name: "MonsterRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint32",
            name: "level",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "experience",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "life",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "mana",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "lifeChances",
            type: "uint32",
          },
        ],
        indexed: false,
        internalType: "struct IStatController.ChangeableStats",
        name: "stats",
        type: "tuple",
      },
    ],
    name: "NewHeroInited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "uint8",
                name: "itemMetaType",
                type: "uint8",
              },
              {
                internalType: "uint8",
                name: "itemLevel",
                type: "uint8",
              },
              {
                internalType: "enum IItemController.ItemType",
                name: "itemType",
                type: "uint8",
              },
              {
                internalType: "uint16",
                name: "baseDurability",
                type: "uint16",
              },
              {
                internalType: "uint8",
                name: "defaultRarity",
                type: "uint8",
              },
              {
                internalType: "uint32",
                name: "manaCost",
                type: "uint32",
              },
              {
                internalType: "uint8",
                name: "minRandomAttributes",
                type: "uint8",
              },
              {
                internalType: "uint8",
                name: "maxRandomAttributes",
                type: "uint8",
              },
              {
                components: [
                  {
                    internalType: "int32",
                    name: "strength",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "dexterity",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "vitality",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "energy",
                    type: "int32",
                  },
                ],
                internalType: "struct IStatController.CoreAttributes",
                name: "requirements",
                type: "tuple",
              },
            ],
            internalType: "struct IItemController.ItemMeta",
            name: "meta",
            type: "tuple",
          },
          {
            internalType: "uint8[]",
            name: "attributesIds",
            type: "uint8[]",
          },
          {
            internalType: "int32[]",
            name: "attributesValues",
            type: "int32[]",
          },
          {
            internalType: "enum IItemController.ItemRarity",
            name: "itemRarity",
            type: "uint8",
          },
          {
            components: [
              {
                internalType: "enum IItemController.AttackType",
                name: "aType",
                type: "uint8",
              },
              {
                internalType: "int32",
                name: "min",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "max",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "int32",
                    name: "strength",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "dexterity",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "vitality",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "energy",
                    type: "int32",
                  },
                ],
                internalType: "struct IStatController.CoreAttributes",
                name: "attributeFactors",
                type: "tuple",
              },
            ],
            internalType: "struct IItemController.AttackInfo",
            name: "attackInfo",
            type: "tuple",
          },
          {
            internalType: "uint8[]",
            name: "casterIds",
            type: "uint8[]",
          },
          {
            internalType: "int32[]",
            name: "casterValues",
            type: "int32[]",
          },
          {
            internalType: "uint8[]",
            name: "targetIds",
            type: "uint8[]",
          },
          {
            internalType: "int32[]",
            name: "targetValues",
            type: "int32[]",
          },
        ],
        indexed: false,
        internalType: "struct IItemController.MintInfo",
        name: "info",
        type: "tuple",
      },
    ],
    name: "NewItemMinted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
    ],
    name: "NewItemSentToSandbox",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "shelterId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "buyerGuildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "NewShelterBid",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "NftRewardRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "consumedItemId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "augLevel",
        type: "uint8",
      },
    ],
    name: "NotAugmented",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "rewardAmountToPay",
        type: "uint256",
      },
    ],
    name: "NotEnoughReward",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "storyId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "nftToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "nftId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stageId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "iteration",
        type: "uint256",
      },
    ],
    name: "NotEquippedItemBurned",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "dungId",
        type: "uint64",
      },
      {
        components: [
          {
            internalType: "bool",
            name: "kill",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "completed",
            type: "bool",
          },
          {
            internalType: "address",
            name: "heroToken",
            type: "address",
          },
          {
            internalType: "address[]",
            name: "mintItems",
            type: "address[]",
          },
          {
            internalType: "int32",
            name: "heal",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaRegen",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "lifeChancesRecovered",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damage",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaConsumed",
            type: "int32",
          },
          {
            internalType: "uint32",
            name: "objectId",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "experience",
            type: "uint32",
          },
          {
            internalType: "uint256",
            name: "heroTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "iteration",
            type: "uint256",
          },
          {
            internalType: "uint32[]",
            name: "rewriteNextObject",
            type: "uint32[]",
          },
        ],
        indexed: false,
        internalType: "struct IGOC.ActionResult",
        name: "result",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "currentStage",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newStage",
        type: "uint256",
      },
    ],
    name: "ObjectAction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "dungId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "objId",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "iteration",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "currentStage",
        type: "uint256",
      },
    ],
    name: "ObjectOpened",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "objectId",
        type: "uint32",
      },
    ],
    name: "ObjectRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "objectId",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "enum IGOC.ObjectType",
        name: "objectType",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "stageId",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "iteration",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        components: [
          {
            internalType: "bool",
            name: "kill",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "completed",
            type: "bool",
          },
          {
            internalType: "address",
            name: "heroToken",
            type: "address",
          },
          {
            internalType: "address[]",
            name: "mintItems",
            type: "address[]",
          },
          {
            internalType: "int32",
            name: "heal",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaRegen",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "lifeChancesRecovered",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damage",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaConsumed",
            type: "int32",
          },
          {
            internalType: "uint32",
            name: "objectId",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "experience",
            type: "uint32",
          },
          {
            internalType: "uint256",
            name: "heroTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "iteration",
            type: "uint256",
          },
          {
            internalType: "uint32[]",
            name: "rewriteNextObject",
            type: "uint32[]",
          },
        ],
        indexed: false,
        internalType: "struct IGOC.ActionResult",
        name: "result",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "salt",
        type: "uint256",
      },
    ],
    name: "ObjectResultEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newGov",
        type: "address",
      },
    ],
    name: "OfferGovernance",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "value",
        type: "address",
      },
    ],
    name: "OracleChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "helpHeroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "helpHeroId",
        type: "uint256",
      },
    ],
    name: "OtherItemGuildReinforcement",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint8",
            name: "itemMetaType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "itemLevel",
            type: "uint8",
          },
          {
            internalType: "enum IItemController.ItemType",
            name: "itemType",
            type: "uint8",
          },
          {
            internalType: "uint16",
            name: "baseDurability",
            type: "uint16",
          },
          {
            internalType: "uint8",
            name: "defaultRarity",
            type: "uint8",
          },
          {
            internalType: "uint32",
            name: "manaCost",
            type: "uint32",
          },
          {
            internalType: "uint8",
            name: "minRandomAttributes",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "maxRandomAttributes",
            type: "uint8",
          },
          {
            components: [
              {
                internalType: "int32",
                name: "strength",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "dexterity",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "vitality",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "energy",
                type: "int32",
              },
            ],
            internalType: "struct IStatController.CoreAttributes",
            name: "requirements",
            type: "tuple",
          },
        ],
        indexed: false,
        internalType: "struct IItemController.ItemMeta",
        name: "meta",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "packedItemMetaData",
        type: "bytes",
      },
    ],
    name: "OtherItemRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
    ],
    name: "OtherItemRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256[]",
        name: "positionIds",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "PawnShopRouterBulkBuy",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address[]",
        name: "nfts",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "nftIds",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "prices",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "address",
        name: "nftOwner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "positionIds",
        type: "uint256[]",
      },
    ],
    name: "PawnShopRouterBulkSell",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256[]",
        name: "positionIds",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "PawnShopRouterClosePositions",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "pawnShop",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "gameToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "routerOwner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "deployed",
        type: "address",
      },
    ],
    name: "PawnShopRouterDeployed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "PawnShopRouterTransfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bid",
        type: "uint256",
      },
    ],
    name: "PayForBidFromGuildBank",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint48",
        name: "fightId",
        type: "uint48",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "week",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroGuildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "opponentHero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "opponentHeroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "opponentGuildId",
        type: "uint256",
      },
    ],
    name: "PreparePvpFight",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "toBurn",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "toTreasury",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "toGov",
        type: "uint256",
      },
    ],
    name: "Process",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "proxy",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "logic",
        type: "address",
      },
    ],
    name: "ProxyUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "msgSender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "numSoldItems",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "priceInPvpPoints",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "priceInGameToken",
        type: "uint256",
      },
    ],
    name: "PurchaseShelterItem",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "value",
        type: "address",
      },
    ],
    name: "PvpControllerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        components: [
          {
            internalType: "bool",
            name: "completed",
            type: "bool",
          },
          {
            internalType: "uint8",
            name: "totalCountFights",
            type: "uint8",
          },
          {
            internalType: "uint32",
            name: "healthHero",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "healthOpponent",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "manaConsumedHero",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "manaConsumedOpponent",
            type: "uint32",
          },
        ],
        indexed: false,
        internalType: "struct IPvpController.PvpFightResults",
        name: "fightResult",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "uint48",
        name: "fightId",
        type: "uint48",
      },
      {
        indexed: false,
        internalType: "address[2]",
        name: "heroes",
        type: "address[2]",
      },
      {
        indexed: false,
        internalType: "uint64[2]",
        name: "guilds",
        type: "uint64[2]",
      },
      {
        indexed: false,
        internalType: "bool[2]",
        name: "winners",
        type: "bool[2]",
      },
      {
        indexed: false,
        internalType: "uint256[2]",
        name: "prizes",
        type: "uint256[2]",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "technicalDefeat",
        type: "bool",
      },
    ],
    name: "PvpFightCompleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint48",
        name: "fightId",
        type: "uint48",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        components: [
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterA",
            type: "tuple",
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterB",
            type: "tuple",
          },
        ],
        indexed: false,
        internalType: "struct IFightCalculator.FightInfoInternal",
        name: "result",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "turn",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "heroA",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroIdA",
        type: "uint256",
      },
    ],
    name: "PvpFightResultProcessed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "week",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
    ],
    name: "PvpHeroAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "week",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "manuallyRemoved",
        type: "bool",
      },
    ],
    name: "PvpHeroRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "number",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "max",
        type: "uint256",
      },
    ],
    name: "Random",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "newNgLevel",
        type: "uint8",
      },
    ],
    name: "Reborn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newDurability",
        type: "uint256",
      },
    ],
    name: "ReduceDurability",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "epochWeek",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "counterPassedDungeons",
        type: "uint256",
      },
    ],
    name: "RegisterPassedDungeon",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "epochWeek",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "counterPvp",
        type: "uint256",
      },
    ],
    name: "RegisterPvp",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tsMinting",
        type: "uint256",
      },
    ],
    name: "RegisterSandboxItem",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tsUpgradng",
        type: "uint256",
      },
    ],
    name: "RegisterSandboxUpgrade",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "sheleterId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    name: "RegisterShelter",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "helpHeroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "helpHeroId",
        type: "uint256",
      },
    ],
    name: "ReinforcementAsked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "value",
        type: "address",
      },
    ],
    name: "ReinforcementControllerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "helperToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "helperId",
        type: "uint256",
      },
    ],
    name: "ReinforcementReleased",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
    ],
    name: "RemoveConsumableUsage",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "RemoveFromGuild",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "shelterId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "items",
        type: "address[]",
      },
    ],
    name: "RemoveShelterItems",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "configId",
        type: "uint256",
      },
    ],
    name: "RemoveUnionConfig",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "consumedItemId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint8[]",
            name: "attributesIds",
            type: "uint8[]",
          },
          {
            internalType: "int32[]",
            name: "attributesValues",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "enum IItemController.AttackType",
                name: "aType",
                type: "uint8",
              },
              {
                internalType: "int32",
                name: "min",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "max",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "int32",
                    name: "strength",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "dexterity",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "vitality",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "energy",
                    type: "int32",
                  },
                ],
                internalType: "struct IStatController.CoreAttributes",
                name: "attributeFactors",
                type: "tuple",
              },
            ],
            internalType: "struct IItemController.AttackInfo",
            name: "attackInfo",
            type: "tuple",
          },
          {
            internalType: "uint8[]",
            name: "casterIds",
            type: "uint8[]",
          },
          {
            internalType: "int32[]",
            name: "casterValues",
            type: "int32[]",
          },
          {
            internalType: "uint8[]",
            name: "targetIds",
            type: "uint8[]",
          },
          {
            internalType: "int32[]",
            name: "targetValues",
            type: "int32[]",
          },
        ],
        indexed: false,
        internalType: "struct IItemController.AugmentInfo",
        name: "info",
        type: "tuple",
      },
    ],
    name: "ResetAugmentation",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "msgSender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
    ],
    name: "RestInShelter",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "shelterId",
        type: "uint256",
      },
    ],
    name: "RevokeShelterBid",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "rewardAmount",
        type: "uint256",
      },
    ],
    name: "RewardSentToUser",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "value",
        type: "address",
      },
    ],
    name: "RewardsPoolChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Salvage",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "dungId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "SandboxReturnAmountToTreasury",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
    ],
    name: "SandboxUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "storyId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint16[]",
            name: "pageId",
            type: "uint16[]",
          },
          {
            internalType: "uint8[]",
            name: "heroClass",
            type: "uint8[]",
          },
          {
            internalType: "uint16[]",
            name: "answerId",
            type: "uint16[]",
          },
          {
            internalType: "bool[][]",
            name: "cores",
            type: "bool[][]",
          },
          {
            internalType: "uint8[][]",
            name: "ids",
            type: "uint8[][]",
          },
          {
            internalType: "int32[][]",
            name: "values",
            type: "int32[][]",
          },
        ],
        indexed: false,
        internalType: "struct IStoryController.AnswerAttributeRequirementsMeta",
        name: "meta",
        type: "tuple",
      },
    ],
    name: "SetAnswerAttributeRequirements",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "storyId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint16[]",
            name: "pageId",
            type: "uint16[]",
          },
          {
            internalType: "uint8[]",
            name: "heroClass",
            type: "uint8[]",
          },
          {
            internalType: "uint16[]",
            name: "answerId",
            type: "uint16[]",
          },
          {
            internalType: "uint32[]",
            name: "randomRequirements",
            type: "uint32[]",
          },
          {
            internalType: "uint32[]",
            name: "delayRequirements",
            type: "uint32[]",
          },
          {
            internalType: "bool[]",
            name: "isFinalAnswer",
            type: "bool[]",
          },
        ],
        indexed: false,
        internalType: "struct IStoryController.AnswerAttributesMeta",
        name: "meta",
        type: "tuple",
      },
    ],
    name: "SetAnswerAttributes",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "storyId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint16[]",
            name: "pageId",
            type: "uint16[]",
          },
          {
            internalType: "uint8[]",
            name: "heroClass",
            type: "uint8[]",
          },
          {
            internalType: "uint16[]",
            name: "answerId",
            type: "uint16[]",
          },
          {
            internalType: "bytes32[][]",
            name: "dataIndexes",
            type: "bytes32[][]",
          },
          {
            internalType: "bool[][]",
            name: "mandatory",
            type: "bool[][]",
          },
          {
            internalType: "uint64[][]",
            name: "dataValuesMin",
            type: "uint64[][]",
          },
          {
            internalType: "uint64[][]",
            name: "dataValuesMax",
            type: "uint64[][]",
          },
        ],
        indexed: false,
        internalType: "struct IStoryController.AnswerCustomDataMeta",
        name: "meta",
        type: "tuple",
      },
    ],
    name: "SetAnswerGlobalCustomDataRequirementMeta",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "storyId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint16[]",
            name: "pageId",
            type: "uint16[]",
          },
          {
            internalType: "uint8[]",
            name: "heroClass",
            type: "uint8[]",
          },
          {
            internalType: "uint16[]",
            name: "answerId",
            type: "uint16[]",
          },
          {
            internalType: "bytes32[][]",
            name: "dataIndexes",
            type: "bytes32[][]",
          },
          {
            internalType: "bool[][]",
            name: "mandatory",
            type: "bool[][]",
          },
          {
            internalType: "uint64[][]",
            name: "dataValuesMin",
            type: "uint64[][]",
          },
          {
            internalType: "uint64[][]",
            name: "dataValuesMax",
            type: "uint64[][]",
          },
        ],
        indexed: false,
        internalType: "struct IStoryController.AnswerCustomDataMeta",
        name: "meta",
        type: "tuple",
      },
    ],
    name: "SetAnswerHeroCustomDataRequirementMeta",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "storyId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint16[]",
            name: "pageId",
            type: "uint16[]",
          },
          {
            internalType: "uint8[]",
            name: "heroClass",
            type: "uint8[]",
          },
          {
            internalType: "uint16[]",
            name: "answerId",
            type: "uint16[]",
          },
          {
            internalType: "address[][]",
            name: "requireItems",
            type: "address[][]",
          },
          {
            internalType: "bool[][]",
            name: "requireItemBurn",
            type: "bool[][]",
          },
          {
            internalType: "bool[][]",
            name: "requireItemEquipped",
            type: "bool[][]",
          },
        ],
        indexed: false,
        internalType: "struct IStoryController.AnswerItemRequirementsMeta",
        name: "meta",
        type: "tuple",
      },
    ],
    name: "SetAnswerItemRequirements",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "storyId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint16[]",
            name: "pageId",
            type: "uint16[]",
          },
          {
            internalType: "uint8[]",
            name: "heroClass",
            type: "uint8[]",
          },
          {
            internalType: "uint16[]",
            name: "answerId",
            type: "uint16[]",
          },
          {
            internalType: "uint8[]",
            name: "answerResultIds",
            type: "uint8[]",
          },
          {
            internalType: "uint16[][]",
            name: "answerNextPageIds",
            type: "uint16[][]",
          },
        ],
        indexed: false,
        internalType: "struct IStoryController.AnswerNextPageMeta",
        name: "meta",
        type: "tuple",
      },
    ],
    name: "SetAnswerNextPageMeta",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "storyId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint16[]",
            name: "pageId",
            type: "uint16[]",
          },
          {
            internalType: "uint8[]",
            name: "heroClass",
            type: "uint8[]",
          },
          {
            internalType: "uint16[]",
            name: "answerId",
            type: "uint16[]",
          },
          {
            internalType: "address[][]",
            name: "requireToken",
            type: "address[][]",
          },
          {
            internalType: "uint88[][]",
            name: "requireAmount",
            type: "uint88[][]",
          },
          {
            internalType: "bool[][]",
            name: "requireTransfer",
            type: "bool[][]",
          },
        ],
        indexed: false,
        internalType: "struct IStoryController.AnswerTokenRequirementsMeta",
        name: "meta",
        type: "tuple",
      },
    ],
    name: "SetAnswerTokenRequirementsMeta",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "storyId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint16[]",
        name: "answerPageIds",
        type: "uint16[]",
      },
      {
        indexed: false,
        internalType: "uint8[]",
        name: "answerHeroClasses",
        type: "uint8[]",
      },
      {
        indexed: false,
        internalType: "uint16[]",
        name: "answerIds",
        type: "uint16[]",
      },
    ],
    name: "SetAnswersMeta",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "keyPassItem",
        type: "address",
      },
    ],
    name: "SetAugmentationProtectiveItem",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "storyId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint16[]",
            name: "pageId",
            type: "uint16[]",
          },
          {
            internalType: "uint8[]",
            name: "heroClass",
            type: "uint8[]",
          },
          {
            internalType: "uint16[]",
            name: "answerId",
            type: "uint16[]",
          },
          {
            internalType: "uint8[][]",
            name: "slots",
            type: "uint8[][]",
          },
          {
            internalType: "uint64[][]",
            name: "chances",
            type: "uint64[][]",
          },
          {
            internalType: "bool[][]",
            name: "isStopIfBurnt",
            type: "bool[][]",
          },
        ],
        indexed: false,
        internalType: "struct IStoryController.AnswerBurnRandomItemMeta",
        name: "meta",
        type: "tuple",
      },
    ],
    name: "SetBurnItemsMeta",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "storyId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint16[]",
            name: "pageId",
            type: "uint16[]",
          },
          {
            internalType: "uint8[]",
            name: "heroClass",
            type: "uint8[]",
          },
          {
            internalType: "uint16[]",
            name: "answerId",
            type: "uint16[]",
          },
          {
            internalType: "bytes32[][]",
            name: "dataIndexes",
            type: "bytes32[][]",
          },
          {
            internalType: "int16[][]",
            name: "dataValues",
            type: "int16[][]",
          },
        ],
        indexed: false,
        internalType: "struct IStoryController.AnswerCustomDataResultMeta",
        name: "meta",
        type: "tuple",
      },
      {
        indexed: false,
        internalType: "enum IStoryController.CustomDataResult",
        name: "_type",
        type: "uint8",
      },
    ],
    name: "SetCustomDataResult",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "storyId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint16[]",
            name: "pageId",
            type: "uint16[]",
          },
          {
            internalType: "uint8[]",
            name: "heroClass",
            type: "uint8[]",
          },
          {
            internalType: "uint16[]",
            name: "answerId",
            type: "uint16[]",
          },
          {
            internalType: "uint8[][]",
            name: "attributeIds",
            type: "uint8[][]",
          },
          {
            internalType: "int32[][]",
            name: "attributeValues",
            type: "int32[][]",
          },
          {
            internalType: "uint32[]",
            name: "experience",
            type: "uint32[]",
          },
          {
            internalType: "int32[]",
            name: "heal",
            type: "int32[]",
          },
          {
            internalType: "int32[]",
            name: "manaRegen",
            type: "int32[]",
          },
          {
            internalType: "int32[]",
            name: "lifeChancesRecovered",
            type: "int32[]",
          },
          {
            internalType: "int32[]",
            name: "damage",
            type: "int32[]",
          },
          {
            internalType: "int32[]",
            name: "manaConsumed",
            type: "int32[]",
          },
          {
            internalType: "address[][]",
            name: "mintItems",
            type: "address[][]",
          },
          {
            internalType: "uint32[][]",
            name: "mintItemsChances",
            type: "uint32[][]",
          },
        ],
        indexed: false,
        internalType: "struct IStoryController.AnswerResultMeta",
        name: "meta",
        type: "tuple",
      },
    ],
    name: "SetFailInfo",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "feeRenaming",
        type: "uint256",
      },
    ],
    name: "SetFeeRenaming",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "fee",
        type: "uint256",
      },
    ],
    name: "SetGuildBaseFee",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId1",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId2",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "peace",
        type: "bool",
      },
    ],
    name: "SetGuildRelation",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "msgSender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "SetGuildRequestDepositAmount",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "adapter",
        type: "address",
      },
    ],
    name: "SetGuildStakingAdapter",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "level",
        type: "uint256",
      },
    ],
    name: "SetMinHeroLevel",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "storyId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint16[]",
            name: "nextObjPageIds",
            type: "uint16[]",
          },
          {
            internalType: "uint8[]",
            name: "nextObjHeroClasses",
            type: "uint8[]",
          },
          {
            internalType: "uint32[][]",
            name: "nextObjIds",
            type: "uint32[][]",
          },
        ],
        indexed: false,
        internalType: "struct IStoryController.NextObjRewriteMeta",
        name: "meta",
        type: "tuple",
      },
    ],
    name: "SetNextObjRewriteMeta",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "remove",
        type: "bool",
      },
    ],
    name: "SetOperator",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "msgSender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "capacityPvpPoints",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "users",
        type: "address[]",
      },
    ],
    name: "SetPvpPointsCapacity",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "shelterAuction",
        type: "address",
      },
    ],
    name: "SetShelterAuction",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "shelterController",
        type: "address",
      },
    ],
    name: "SetShelterController",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "shelterId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "items",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint64[]",
        name: "pricesInPvpPoints",
        type: "uint64[]",
      },
      {
        indexed: false,
        internalType: "uint128[]",
        name: "pricesInGameTokens",
        type: "uint128[]",
      },
      {
        indexed: false,
        internalType: "uint16[]",
        name: "maxItemsPerDayThresholds",
        type: "uint16[]",
      },
    ],
    name: "SetShelterItems",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "SetStakingToken",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
    ],
    name: "SetStoryPassed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "storyId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint16[]",
            name: "pageId",
            type: "uint16[]",
          },
          {
            internalType: "uint8[]",
            name: "heroClass",
            type: "uint8[]",
          },
          {
            internalType: "uint16[]",
            name: "answerId",
            type: "uint16[]",
          },
          {
            internalType: "uint8[][]",
            name: "attributeIds",
            type: "uint8[][]",
          },
          {
            internalType: "int32[][]",
            name: "attributeValues",
            type: "int32[][]",
          },
          {
            internalType: "uint32[]",
            name: "experience",
            type: "uint32[]",
          },
          {
            internalType: "int32[]",
            name: "heal",
            type: "int32[]",
          },
          {
            internalType: "int32[]",
            name: "manaRegen",
            type: "int32[]",
          },
          {
            internalType: "int32[]",
            name: "lifeChancesRecovered",
            type: "int32[]",
          },
          {
            internalType: "int32[]",
            name: "damage",
            type: "int32[]",
          },
          {
            internalType: "int32[]",
            name: "manaConsumed",
            type: "int32[]",
          },
          {
            internalType: "address[][]",
            name: "mintItems",
            type: "address[][]",
          },
          {
            internalType: "uint32[][]",
            name: "mintItemsChances",
            type: "uint32[][]",
          },
        ],
        indexed: false,
        internalType: "struct IStoryController.AnswerResultMeta",
        name: "meta",
        type: "tuple",
      },
    ],
    name: "SetSuccessInfo",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "value",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "SetToHelperRatio",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "msgSender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "toHelperRatio",
        type: "uint8",
      },
    ],
    name: "SetToHelperRatio",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "configId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "items",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "count",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "address",
        name: "itemToMint",
        type: "address",
      },
    ],
    name: "SetUnionConfig",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "keyPassItem",
        type: "address",
      },
    ],
    name: "SetUnionKeyPass",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "avatar",
        type: "string",
      },
    ],
    name: "SetUserAvatar",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "paramId",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "paramValue",
        type: "uint256",
      },
    ],
    name: "SetUserControllerParam",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "name",
        type: "string",
      },
    ],
    name: "SetUserName",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "msgSender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "heroAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "heroName",
        type: "string",
      },
    ],
    name: "SponsoredHeroCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "total",
        type: "uint256",
      },
    ],
    name: "StakeTokens",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "value",
        type: "address",
      },
    ],
    name: "StatControllerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "objectId",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "dungeonId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "storyId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "stageId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "iteration",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "int32[]",
        name: "attributes",
        type: "int32[]",
      },
    ],
    name: "StoryChangeAttributes",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "value",
        type: "address",
      },
    ],
    name: "StoryControllerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "storyId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "requiredCustomDataIndex",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "requiredCustomDataMinValue",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "requiredCustomDataMaxValue",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "requiredCustomDataIsHero",
        type: "bool",
      },
    ],
    name: "StoryCustomDataRequirements",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "objectId",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "storyId",
        type: "uint256",
      },
    ],
    name: "StoryFinalized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "objectId",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
    ],
    name: "StoryRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint32",
        name: "objectId",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "storyId",
        type: "uint256",
      },
    ],
    name: "StoryRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "storyId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "requiredLevel",
        type: "uint256",
      },
    ],
    name: "StoryRequiredLevel",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "itemSlot",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "address",
        name: "destination",
        type: "address",
      },
    ],
    name: "TakenOff",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "caller",
        type: "address",
      },
    ],
    name: "TemporallyAttributesCleared",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "tier",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint72",
        name: "payAmount",
        type: "uint72",
      },
      {
        indexed: false,
        internalType: "uint8[]",
        name: "slots",
        type: "uint8[]",
      },
      {
        indexed: false,
        internalType: "address[][]",
        name: "items",
        type: "address[][]",
      },
    ],
    name: "TierSetup",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "ToHelperRatioChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amountAdded",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalAmount",
        type: "uint256",
      },
    ],
    name: "TokenRewardRegistered",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "status",
        type: "bool",
      },
    ],
    name: "TokenStatusChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "msgSender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "guildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "guildBank",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "TopUpGuildBank",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "TransferFromGuildBank",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "itemId",
        type: "uint256",
      },
    ],
    name: "TransferItemToHeroFromSandbox",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "nfts",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "tokenIds",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "TransferNftFromGuildBank",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "prevOwner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "TransferOwnership",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "value",
        type: "address",
      },
    ],
    name: "TreasuryChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "uri",
        type: "string",
      },
    ],
    name: "UniqueUriChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "biome",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "week",
        type: "uint32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "guildBiomeOwnerId",
        type: "uint256",
      },
    ],
    name: "UpdatePvpEpoch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "uri",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "rarity",
        type: "uint256",
      },
    ],
    name: "UriByRarityChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "storyId",
        type: "uint16",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "priceInGamePoints",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "finalBalanceGamePoints",
        type: "uint256",
      },
    ],
    name: "UseGamePointsToSkipStory",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "shelterId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "sellerGuildId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "buyerGuidId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "UseShelterBid",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "item",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "heroToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroTokenId",
        type: "uint256",
      },
    ],
    name: "Used",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "value",
        type: "address",
      },
    ],
    name: "UserControllerChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "hero",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "heroId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "items",
        type: "address[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "itemIds",
        type: "uint256[]",
      },
    ],
    name: "WithdrawItemsFromSandbox",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "attributeValue",
        type: "int32",
      },
      {
        internalType: "uint256",
        name: "y0",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "k",
        type: "uint256",
      },
    ],
    name: "_getAdjustedValue",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32[]",
        name: "attributes",
        type: "int32[]",
      },
      {
        internalType: "enum IStatController.ATTRIBUTES",
        name: "attrId",
        type: "uint8",
      },
    ],
    name: "_getAttrValue",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int32[]",
            name: "fighterAttributes",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "level",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "experience",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "life",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "mana",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "lifeChances",
                type: "uint32",
              },
            ],
            internalType: "struct IStatController.ChangeableStats",
            name: "fighterStats",
            type: "tuple",
          },
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "race",
            type: "uint256",
          },
        ],
        internalType: "struct IFightCalculator.FighterInfo",
        name: "attackerInfo",
        type: "tuple",
      },
      {
        internalType: "enum IItemController.AttackType",
        name: "aType",
        type: "uint8",
      },
      {
        internalType: "enum IStatController.ATTRIBUTES",
        name: "index",
        type: "uint8",
      },
      {
        internalType: "int32",
        name: "resist",
        type: "int32",
      },
    ],
    name: "_getChance",
    outputs: [
      {
        internalType: "int32",
        name: "chance",
        type: "int32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterA",
            type: "tuple",
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterB",
            type: "tuple",
          },
        ],
        internalType: "struct IFightCalculator.FightInfoInternal",
        name: "fInfo",
        type: "tuple",
      },
    ],
    name: "calcFirstHit",
    outputs: [
      {
        internalType: "bool",
        name: "aFirst",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "controller",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "dmg",
        type: "int32",
      },
      {
        components: [
          {
            internalType: "int32[]",
            name: "fighterAttributes",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "level",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "experience",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "life",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "mana",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "lifeChances",
                type: "uint32",
              },
            ],
            internalType: "struct IStatController.ChangeableStats",
            name: "fighterStats",
            type: "tuple",
          },
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "race",
            type: "uint256",
          },
        ],
        internalType: "struct IFightCalculator.FighterInfo",
        name: "defenderInfo",
        type: "tuple",
      },
    ],
    name: "decreaseDmgByDmgReduction",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "dmg",
        type: "int32",
      },
      {
        components: [
          {
            internalType: "int32[]",
            name: "fighterAttributes",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "level",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "experience",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "life",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "mana",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "lifeChances",
                type: "uint32",
              },
            ],
            internalType: "struct IStatController.ChangeableStats",
            name: "fighterStats",
            type: "tuple",
          },
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "race",
            type: "uint256",
          },
        ],
        internalType: "struct IFightCalculator.FighterInfo",
        name: "defenderInfo",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "attackerRace",
        type: "uint256",
      },
    ],
    name: "decreaseRaceDmg",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "int32[]",
                name: "fighterAttributes",
                type: "int32[]",
              },
              {
                components: [
                  {
                    internalType: "uint32",
                    name: "level",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "experience",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "life",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "mana",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "lifeChances",
                    type: "uint32",
                  },
                ],
                internalType: "struct IStatController.ChangeableStats",
                name: "fighterStats",
                type: "tuple",
              },
              {
                internalType: "enum IFightCalculator.AttackType",
                name: "attackType",
                type: "uint8",
              },
              {
                internalType: "address",
                name: "attackToken",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "attackTokenId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "race",
                type: "uint256",
              },
            ],
            internalType: "struct IFightCalculator.FighterInfo",
            name: "fighterA",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "int32[]",
                name: "fighterAttributes",
                type: "int32[]",
              },
              {
                components: [
                  {
                    internalType: "uint32",
                    name: "level",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "experience",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "life",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "mana",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "lifeChances",
                    type: "uint32",
                  },
                ],
                internalType: "struct IStatController.ChangeableStats",
                name: "fighterStats",
                type: "tuple",
              },
              {
                internalType: "enum IFightCalculator.AttackType",
                name: "attackType",
                type: "uint8",
              },
              {
                internalType: "address",
                name: "attackToken",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "attackTokenId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "race",
                type: "uint256",
              },
            ],
            internalType: "struct IFightCalculator.FighterInfo",
            name: "fighterB",
            type: "tuple",
          },
          {
            internalType: "uint64",
            name: "dungeonId",
            type: "uint64",
          },
          {
            internalType: "uint32",
            name: "objectId",
            type: "uint32",
          },
          {
            internalType: "address",
            name: "heroAdr",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "heroId",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "stageId",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "iteration",
            type: "uint256",
          },
          {
            internalType: "uint8",
            name: "turn",
            type: "uint8",
          },
        ],
        internalType: "struct IFightCalculator.FightCall",
        name: "callData",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "msgSender",
            type: "address",
          },
          {
            internalType: "uint48",
            name: "fightId",
            type: "uint48",
          },
        ],
        internalType: "struct IFightCalculator.FightCallAdd",
        name: "fightCallAdd",
        type: "tuple",
      },
    ],
    name: "fight",
    outputs: [
      {
        components: [
          {
            internalType: "int32",
            name: "healthA",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "healthB",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaConsumedA",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaConsumedB",
            type: "int32",
          },
        ],
        internalType: "struct IFightCalculator.FightResult",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterA",
            type: "tuple",
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterB",
            type: "tuple",
          },
        ],
        internalType: "struct IFightCalculator.FightInfoInternal",
        name: "fResult",
        type: "tuple",
      },
    ],
    name: "fightProcessing",
    outputs: [
      {
        components: [
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterA",
            type: "tuple",
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterB",
            type: "tuple",
          },
        ],
        internalType: "struct IFightCalculator.FightInfoInternal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "y0",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "x",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "k",
        type: "uint256",
      },
    ],
    name: "getReducedValue",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "dmg",
        type: "int32",
      },
      {
        components: [
          {
            internalType: "int32[]",
            name: "fighterAttributes",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "level",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "experience",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "life",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "mana",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "lifeChances",
                type: "uint32",
              },
            ],
            internalType: "struct IStatController.ChangeableStats",
            name: "fighterStats",
            type: "tuple",
          },
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "race",
            type: "uint256",
          },
        ],
        internalType: "struct IFightCalculator.FighterInfo",
        name: "attackerInfo",
        type: "tuple",
      },
      {
        internalType: "enum IItemController.AttackType",
        name: "aType",
        type: "uint8",
      },
    ],
    name: "increaseMagicDmgByFactor",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "dmg",
        type: "int32",
      },
      {
        components: [
          {
            internalType: "int32[]",
            name: "fighterAttributes",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "level",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "experience",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "life",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "mana",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "lifeChances",
                type: "uint32",
              },
            ],
            internalType: "struct IStatController.ChangeableStats",
            name: "fighterStats",
            type: "tuple",
          },
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "race",
            type: "uint256",
          },
        ],
        internalType: "struct IFightCalculator.FighterInfo",
        name: "attackerInfo",
        type: "tuple",
      },
    ],
    name: "increaseMeleeDmgByFactor",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "dmg",
        type: "int32",
      },
      {
        components: [
          {
            internalType: "int32[]",
            name: "fighterAttributes",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "level",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "experience",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "life",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "mana",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "lifeChances",
                type: "uint32",
              },
            ],
            internalType: "struct IStatController.ChangeableStats",
            name: "fighterStats",
            type: "tuple",
          },
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "race",
            type: "uint256",
          },
        ],
        internalType: "struct IFightCalculator.FighterInfo",
        name: "attackerInfo",
        type: "tuple",
      },
      {
        internalType: "uint256",
        name: "defenderRace",
        type: "uint256",
      },
    ],
    name: "increaseRaceDmg",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int32[]",
            name: "fighterAttributes",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "level",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "experience",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "life",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "mana",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "lifeChances",
                type: "uint32",
              },
            ],
            internalType: "struct IStatController.ChangeableStats",
            name: "fighterStats",
            type: "tuple",
          },
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "race",
            type: "uint256",
          },
        ],
        internalType: "struct IFightCalculator.FighterInfo",
        name: "fighterAInfo",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "int32[]",
            name: "fighterAttributes",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "level",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "experience",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "life",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "mana",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "lifeChances",
                type: "uint32",
              },
            ],
            internalType: "struct IStatController.ChangeableStats",
            name: "fighterStats",
            type: "tuple",
          },
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "race",
            type: "uint256",
          },
        ],
        internalType: "struct IFightCalculator.FighterInfo",
        name: "fighterBInfo",
        type: "tuple",
      },
    ],
    name: "isAttackerFaster",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "dmg",
        type: "int32",
      },
      {
        components: [
          {
            internalType: "int32[]",
            name: "fighterAttributes",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "level",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "experience",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "life",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "mana",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "lifeChances",
                type: "uint32",
              },
            ],
            internalType: "struct IStatController.ChangeableStats",
            name: "fighterStats",
            type: "tuple",
          },
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "race",
            type: "uint256",
          },
        ],
        internalType: "struct IFightCalculator.FighterInfo",
        name: "attackerInfo",
        type: "tuple",
      },
    ],
    name: "lifeStolenPerHit",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int32[]",
            name: "fighterAttributes",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "level",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "experience",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "life",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "mana",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "lifeChances",
                type: "uint32",
              },
            ],
            internalType: "struct IStatController.ChangeableStats",
            name: "fighterStats",
            type: "tuple",
          },
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "race",
            type: "uint256",
          },
        ],
        internalType: "struct IFightCalculator.FighterInfo",
        name: "attackerInfo",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "int32[]",
            name: "fighterAttributes",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "level",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "experience",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "life",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "mana",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "lifeChances",
                type: "uint32",
              },
            ],
            internalType: "struct IStatController.ChangeableStats",
            name: "fighterStats",
            type: "tuple",
          },
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "race",
            type: "uint256",
          },
        ],
        internalType: "struct IFightCalculator.FighterInfo",
        name: "defenderInfo",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum IItemController.AttackType",
            name: "aType",
            type: "uint8",
          },
          {
            internalType: "int32",
            name: "min",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "max",
            type: "int32",
          },
          {
            components: [
              {
                internalType: "int32",
                name: "strength",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "dexterity",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "vitality",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "energy",
                type: "int32",
              },
            ],
            internalType: "struct IStatController.CoreAttributes",
            name: "attributeFactors",
            type: "tuple",
          },
        ],
        internalType: "struct IItemController.AttackInfo",
        name: "magicAttack",
        type: "tuple",
      },
      {
        internalType: "int32",
        name: "defenderHealth",
        type: "int32",
      },
    ],
    name: "magicDamageCalculation",
    outputs: [
      {
        components: [
          {
            internalType: "int32",
            name: "defenderHealth",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damage",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "lifeStolen",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "reflectDamage",
            type: "int32",
          },
          {
            internalType: "uint8",
            name: "critical",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "missed",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "blocked",
            type: "uint8",
          },
        ],
        internalType: "struct FightLib.AttackResult",
        name: "attackResult",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int32[]",
            name: "fighterAttributes",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "level",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "experience",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "life",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "mana",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "lifeChances",
                type: "uint32",
              },
            ],
            internalType: "struct IStatController.ChangeableStats",
            name: "fighterStats",
            type: "tuple",
          },
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "race",
            type: "uint256",
          },
        ],
        internalType: "struct IFightCalculator.FighterInfo",
        name: "attackerInfo",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "int32[]",
            name: "fighterAttributes",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "level",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "experience",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "life",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "mana",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "lifeChances",
                type: "uint32",
              },
            ],
            internalType: "struct IStatController.ChangeableStats",
            name: "fighterStats",
            type: "tuple",
          },
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "race",
            type: "uint256",
          },
        ],
        internalType: "struct IFightCalculator.FighterInfo",
        name: "defenderInfo",
        type: "tuple",
      },
      {
        internalType: "int32",
        name: "defenderHealth",
        type: "int32",
      },
    ],
    name: "meleeDamageCalculation",
    outputs: [
      {
        components: [
          {
            internalType: "int32",
            name: "defenderHealth",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damage",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "lifeStolen",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "reflectDamage",
            type: "int32",
          },
          {
            internalType: "uint8",
            name: "critical",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "missed",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "blocked",
            type: "uint8",
          },
        ],
        internalType: "struct FightLib.AttackResult",
        name: "attackResult",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "health",
        type: "int32",
      },
      {
        components: [
          {
            internalType: "bool",
            name: "stun",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "burn",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "freeze",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "confuse",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "curse",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "poison",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "gotCriticalHit",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "missed",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "hitBlocked",
            type: "bool",
          },
        ],
        internalType: "struct IFightCalculator.Statuses",
        name: "statuses",
        type: "tuple",
      },
    ],
    name: "poisonDmg",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int32[]",
            name: "fighterAttributes",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "level",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "experience",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "life",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "mana",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "lifeChances",
                type: "uint32",
              },
            ],
            internalType: "struct IStatController.ChangeableStats",
            name: "fighterStats",
            type: "tuple",
          },
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "race",
            type: "uint256",
          },
        ],
        internalType: "struct IFightCalculator.FighterInfo",
        name: "fighterA",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "int32[]",
            name: "fighterAttributes",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "level",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "experience",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "life",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "mana",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "lifeChances",
                type: "uint32",
              },
            ],
            internalType: "struct IStatController.ChangeableStats",
            name: "fighterStats",
            type: "tuple",
          },
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "race",
            type: "uint256",
          },
        ],
        internalType: "struct IFightCalculator.FighterInfo",
        name: "fighterB",
        type: "tuple",
      },
    ],
    name: "prepareFightInternalInfo",
    outputs: [
      {
        components: [
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterA",
            type: "tuple",
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterB",
            type: "tuple",
          },
        ],
        internalType: "struct IFightCalculator.FightInfoInternal",
        name: "fInfo",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterA",
            type: "tuple",
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterB",
            type: "tuple",
          },
        ],
        internalType: "struct IFightCalculator.FightInfoInternal",
        name: "fResult",
        type: "tuple",
      },
      {
        internalType: "bool",
        name: "isA",
        type: "bool",
      },
    ],
    name: "processAttack",
    outputs: [
      {
        components: [
          {
            internalType: "int32",
            name: "defenderHealth",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damage",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "lifeStolen",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "reflectDamage",
            type: "int32",
          },
          {
            internalType: "uint8",
            name: "critical",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "missed",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "blocked",
            type: "uint8",
          },
        ],
        internalType: "struct FightLib.AttackResult",
        name: "attackResult",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32[]",
        name: "targetAttributes",
        type: "int32[]",
      },
      {
        components: [
          {
            internalType: "bool",
            name: "stun",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "burn",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "freeze",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "confuse",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "curse",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "poison",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "gotCriticalHit",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "missed",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "hitBlocked",
            type: "bool",
          },
        ],
        internalType: "struct IFightCalculator.Statuses",
        name: "statuses",
        type: "tuple",
      },
      {
        internalType: "int32[]",
        name: "casterAttributes",
        type: "int32[]",
      },
    ],
    name: "reduceAttributesByStatuses",
    outputs: [
      {
        internalType: "int32[]",
        name: "targetAttributesOut",
        type: "int32[]",
      },
      {
        internalType: "int32[]",
        name: "casterAttributesOut",
        type: "int32[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int32",
            name: "defenderHealth",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damage",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "lifeStolen",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "reflectDamage",
            type: "int32",
          },
          {
            internalType: "uint8",
            name: "critical",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "missed",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "blocked",
            type: "uint8",
          },
        ],
        internalType: "struct FightLib.AttackResult",
        name: "firstAttack",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "int32",
            name: "defenderHealth",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damage",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "lifeStolen",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "reflectDamage",
            type: "int32",
          },
          {
            internalType: "uint8",
            name: "critical",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "missed",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "blocked",
            type: "uint8",
          },
        ],
        internalType: "struct FightLib.AttackResult",
        name: "secondAttack",
        type: "tuple",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "int32[]",
                name: "fighterAttributes",
                type: "int32[]",
              },
              {
                components: [
                  {
                    internalType: "uint32",
                    name: "level",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "experience",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "life",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "mana",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "lifeChances",
                    type: "uint32",
                  },
                ],
                internalType: "struct IStatController.ChangeableStats",
                name: "fighterStats",
                type: "tuple",
              },
              {
                internalType: "enum IFightCalculator.AttackType",
                name: "attackType",
                type: "uint8",
              },
              {
                internalType: "address",
                name: "attackToken",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "attackTokenId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "race",
                type: "uint256",
              },
            ],
            internalType: "struct IFightCalculator.FighterInfo",
            name: "info",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "enum IItemController.AttackType",
                name: "aType",
                type: "uint8",
              },
              {
                internalType: "int32",
                name: "min",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "max",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "int32",
                    name: "strength",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "dexterity",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "vitality",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "energy",
                    type: "int32",
                  },
                ],
                internalType: "struct IStatController.CoreAttributes",
                name: "attributeFactors",
                type: "tuple",
              },
            ],
            internalType: "struct IItemController.AttackInfo",
            name: "magicAttack",
            type: "tuple",
          },
          {
            internalType: "int32",
            name: "health",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaConsumed",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damage",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damagePoison",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damageReflect",
            type: "int32",
          },
          {
            components: [
              {
                internalType: "bool",
                name: "stun",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "burn",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "freeze",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "confuse",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "curse",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "poison",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "gotCriticalHit",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "missed",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "hitBlocked",
                type: "bool",
              },
            ],
            internalType: "struct IFightCalculator.Statuses",
            name: "statuses",
            type: "tuple",
          },
        ],
        internalType: "struct IFightCalculator.Fighter",
        name: "firstFighter",
        type: "tuple",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "int32[]",
                name: "fighterAttributes",
                type: "int32[]",
              },
              {
                components: [
                  {
                    internalType: "uint32",
                    name: "level",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "experience",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "life",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "mana",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "lifeChances",
                    type: "uint32",
                  },
                ],
                internalType: "struct IStatController.ChangeableStats",
                name: "fighterStats",
                type: "tuple",
              },
              {
                internalType: "enum IFightCalculator.AttackType",
                name: "attackType",
                type: "uint8",
              },
              {
                internalType: "address",
                name: "attackToken",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "attackTokenId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "race",
                type: "uint256",
              },
            ],
            internalType: "struct IFightCalculator.FighterInfo",
            name: "info",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "enum IItemController.AttackType",
                name: "aType",
                type: "uint8",
              },
              {
                internalType: "int32",
                name: "min",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "max",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "int32",
                    name: "strength",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "dexterity",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "vitality",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "energy",
                    type: "int32",
                  },
                ],
                internalType: "struct IStatController.CoreAttributes",
                name: "attributeFactors",
                type: "tuple",
              },
            ],
            internalType: "struct IItemController.AttackInfo",
            name: "magicAttack",
            type: "tuple",
          },
          {
            internalType: "int32",
            name: "health",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaConsumed",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damage",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damagePoison",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damageReflect",
            type: "int32",
          },
          {
            components: [
              {
                internalType: "bool",
                name: "stun",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "burn",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "freeze",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "confuse",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "curse",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "poison",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "gotCriticalHit",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "missed",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "hitBlocked",
                type: "bool",
              },
            ],
            internalType: "struct IFightCalculator.Statuses",
            name: "statuses",
            type: "tuple",
          },
        ],
        internalType: "struct IFightCalculator.Fighter",
        name: "secondFighter",
        type: "tuple",
      },
    ],
    name: "reduceHp",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "int32[]",
                name: "fighterAttributes",
                type: "int32[]",
              },
              {
                components: [
                  {
                    internalType: "uint32",
                    name: "level",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "experience",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "life",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "mana",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "lifeChances",
                    type: "uint32",
                  },
                ],
                internalType: "struct IStatController.ChangeableStats",
                name: "fighterStats",
                type: "tuple",
              },
              {
                internalType: "enum IFightCalculator.AttackType",
                name: "attackType",
                type: "uint8",
              },
              {
                internalType: "address",
                name: "attackToken",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "attackTokenId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "race",
                type: "uint256",
              },
            ],
            internalType: "struct IFightCalculator.FighterInfo",
            name: "info",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "enum IItemController.AttackType",
                name: "aType",
                type: "uint8",
              },
              {
                internalType: "int32",
                name: "min",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "max",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "int32",
                    name: "strength",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "dexterity",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "vitality",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "energy",
                    type: "int32",
                  },
                ],
                internalType: "struct IStatController.CoreAttributes",
                name: "attributeFactors",
                type: "tuple",
              },
            ],
            internalType: "struct IItemController.AttackInfo",
            name: "magicAttack",
            type: "tuple",
          },
          {
            internalType: "int32",
            name: "health",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaConsumed",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damage",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damagePoison",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damageReflect",
            type: "int32",
          },
          {
            components: [
              {
                internalType: "bool",
                name: "stun",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "burn",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "freeze",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "confuse",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "curse",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "poison",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "gotCriticalHit",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "missed",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "hitBlocked",
                type: "bool",
              },
            ],
            internalType: "struct IFightCalculator.Statuses",
            name: "statuses",
            type: "tuple",
          },
        ],
        internalType: "struct IFightCalculator.Fighter",
        name: "firstFighterOut",
        type: "tuple",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "int32[]",
                name: "fighterAttributes",
                type: "int32[]",
              },
              {
                components: [
                  {
                    internalType: "uint32",
                    name: "level",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "experience",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "life",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "mana",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "lifeChances",
                    type: "uint32",
                  },
                ],
                internalType: "struct IStatController.ChangeableStats",
                name: "fighterStats",
                type: "tuple",
              },
              {
                internalType: "enum IFightCalculator.AttackType",
                name: "attackType",
                type: "uint8",
              },
              {
                internalType: "address",
                name: "attackToken",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "attackTokenId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "race",
                type: "uint256",
              },
            ],
            internalType: "struct IFightCalculator.FighterInfo",
            name: "info",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "enum IItemController.AttackType",
                name: "aType",
                type: "uint8",
              },
              {
                internalType: "int32",
                name: "min",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "max",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "int32",
                    name: "strength",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "dexterity",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "vitality",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "energy",
                    type: "int32",
                  },
                ],
                internalType: "struct IStatController.CoreAttributes",
                name: "attributeFactors",
                type: "tuple",
              },
            ],
            internalType: "struct IItemController.AttackInfo",
            name: "magicAttack",
            type: "tuple",
          },
          {
            internalType: "int32",
            name: "health",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaConsumed",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damage",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damagePoison",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damageReflect",
            type: "int32",
          },
          {
            components: [
              {
                internalType: "bool",
                name: "stun",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "burn",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "freeze",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "confuse",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "curse",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "poison",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "gotCriticalHit",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "missed",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "hitBlocked",
                type: "bool",
              },
            ],
            internalType: "struct IFightCalculator.Statuses",
            name: "statuses",
            type: "tuple",
          },
        ],
        internalType: "struct IFightCalculator.Fighter",
        name: "secondFighterOut",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "dmg",
        type: "int32",
      },
      {
        components: [
          {
            internalType: "int32[]",
            name: "fighterAttributes",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "level",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "experience",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "life",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "mana",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "lifeChances",
                type: "uint32",
              },
            ],
            internalType: "struct IStatController.ChangeableStats",
            name: "fighterStats",
            type: "tuple",
          },
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "race",
            type: "uint256",
          },
        ],
        internalType: "struct IFightCalculator.FighterInfo",
        name: "defenderInfo",
        type: "tuple",
      },
    ],
    name: "reflectMagicDmg",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int32",
        name: "dmg",
        type: "int32",
      },
      {
        components: [
          {
            internalType: "int32[]",
            name: "fighterAttributes",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "level",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "experience",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "life",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "mana",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "lifeChances",
                type: "uint32",
              },
            ],
            internalType: "struct IStatController.ChangeableStats",
            name: "fighterStats",
            type: "tuple",
          },
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "race",
            type: "uint256",
          },
        ],
        internalType: "struct IFightCalculator.FighterInfo",
        name: "defenderInfo",
        type: "tuple",
      },
    ],
    name: "reflectMeleeDmg",
    outputs: [
      {
        internalType: "int32",
        name: "",
        type: "int32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "controller_",
        type: "address",
      },
    ],
    name: "setController",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "max",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "setPseudoRandomForTests",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterA",
            type: "tuple",
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterB",
            type: "tuple",
          },
        ],
        internalType: "struct IFightCalculator.FightInfoInternal",
        name: "fResult",
        type: "tuple",
      },
      {
        internalType: "bool",
        name: "isA",
        type: "bool",
      },
    ],
    name: "setStatuses",
    outputs: [
      {
        components: [
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterA",
            type: "tuple",
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterB",
            type: "tuple",
          },
        ],
        internalType: "struct IFightCalculator.FightInfoInternal",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterA",
            type: "tuple",
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "int32[]",
                    name: "fighterAttributes",
                    type: "int32[]",
                  },
                  {
                    components: [
                      {
                        internalType: "uint32",
                        name: "level",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "experience",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "life",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "mana",
                        type: "uint32",
                      },
                      {
                        internalType: "uint32",
                        name: "lifeChances",
                        type: "uint32",
                      },
                    ],
                    internalType: "struct IStatController.ChangeableStats",
                    name: "fighterStats",
                    type: "tuple",
                  },
                  {
                    internalType: "enum IFightCalculator.AttackType",
                    name: "attackType",
                    type: "uint8",
                  },
                  {
                    internalType: "address",
                    name: "attackToken",
                    type: "address",
                  },
                  {
                    internalType: "uint256",
                    name: "attackTokenId",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "race",
                    type: "uint256",
                  },
                ],
                internalType: "struct IFightCalculator.FighterInfo",
                name: "info",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "enum IItemController.AttackType",
                    name: "aType",
                    type: "uint8",
                  },
                  {
                    internalType: "int32",
                    name: "min",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "max",
                    type: "int32",
                  },
                  {
                    components: [
                      {
                        internalType: "int32",
                        name: "strength",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "dexterity",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "vitality",
                        type: "int32",
                      },
                      {
                        internalType: "int32",
                        name: "energy",
                        type: "int32",
                      },
                    ],
                    internalType: "struct IStatController.CoreAttributes",
                    name: "attributeFactors",
                    type: "tuple",
                  },
                ],
                internalType: "struct IItemController.AttackInfo",
                name: "magicAttack",
                type: "tuple",
              },
              {
                internalType: "int32",
                name: "health",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "manaConsumed",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damage",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damagePoison",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "damageReflect",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "bool",
                    name: "stun",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "burn",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "freeze",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "confuse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "curse",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "poison",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "gotCriticalHit",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "missed",
                    type: "bool",
                  },
                  {
                    internalType: "bool",
                    name: "hitBlocked",
                    type: "bool",
                  },
                ],
                internalType: "struct IFightCalculator.Statuses",
                name: "statuses",
                type: "tuple",
              },
            ],
            internalType: "struct IFightCalculator.Fighter",
            name: "fighterB",
            type: "tuple",
          },
        ],
        internalType: "struct IFightCalculator.FightInfoInternal",
        name: "fResult",
        type: "tuple",
      },
      {
        internalType: "bool",
        name: "isA",
        type: "bool",
      },
    ],
    name: "skipTurn",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "int32[]",
            name: "fighterAttributes",
            type: "int32[]",
          },
          {
            components: [
              {
                internalType: "uint32",
                name: "level",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "experience",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "life",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "mana",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "lifeChances",
                type: "uint32",
              },
            ],
            internalType: "struct IStatController.ChangeableStats",
            name: "fighterStats",
            type: "tuple",
          },
          {
            internalType: "enum IFightCalculator.AttackType",
            name: "attackType",
            type: "uint8",
          },
          {
            internalType: "address",
            name: "attackToken",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "attackTokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "race",
            type: "uint256",
          },
        ],
        internalType: "struct IFightCalculator.FighterInfo",
        name: "attackerInfo",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "enum IItemController.AttackType",
            name: "aType",
            type: "uint8",
          },
          {
            internalType: "int32",
            name: "min",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "max",
            type: "int32",
          },
          {
            components: [
              {
                internalType: "int32",
                name: "strength",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "dexterity",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "vitality",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "energy",
                type: "int32",
              },
            ],
            internalType: "struct IStatController.CoreAttributes",
            name: "attributeFactors",
            type: "tuple",
          },
        ],
        internalType: "struct IItemController.AttackInfo",
        name: "attackerMA",
        type: "tuple",
      },
      {
        internalType: "enum IStatController.ATTRIBUTES",
        name: "index",
        type: "uint8",
      },
      {
        internalType: "int32",
        name: "resist",
        type: "int32",
      },
    ],
    name: "statusChance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "int32[]",
                name: "fighterAttributes",
                type: "int32[]",
              },
              {
                components: [
                  {
                    internalType: "uint32",
                    name: "level",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "experience",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "life",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "mana",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "lifeChances",
                    type: "uint32",
                  },
                ],
                internalType: "struct IStatController.ChangeableStats",
                name: "fighterStats",
                type: "tuple",
              },
              {
                internalType: "enum IFightCalculator.AttackType",
                name: "attackType",
                type: "uint8",
              },
              {
                internalType: "address",
                name: "attackToken",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "attackTokenId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "race",
                type: "uint256",
              },
            ],
            internalType: "struct IFightCalculator.FighterInfo",
            name: "info",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "enum IItemController.AttackType",
                name: "aType",
                type: "uint8",
              },
              {
                internalType: "int32",
                name: "min",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "max",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "int32",
                    name: "strength",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "dexterity",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "vitality",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "energy",
                    type: "int32",
                  },
                ],
                internalType: "struct IStatController.CoreAttributes",
                name: "attributeFactors",
                type: "tuple",
              },
            ],
            internalType: "struct IItemController.AttackInfo",
            name: "magicAttack",
            type: "tuple",
          },
          {
            internalType: "int32",
            name: "health",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaConsumed",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damage",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damagePoison",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damageReflect",
            type: "int32",
          },
          {
            components: [
              {
                internalType: "bool",
                name: "stun",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "burn",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "freeze",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "confuse",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "curse",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "poison",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "gotCriticalHit",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "missed",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "hitBlocked",
                type: "bool",
              },
            ],
            internalType: "struct IFightCalculator.Statuses",
            name: "statuses",
            type: "tuple",
          },
        ],
        internalType: "struct IFightCalculator.Fighter",
        name: "fighter",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "int32",
            name: "defenderHealth",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damage",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "lifeStolen",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "reflectDamage",
            type: "int32",
          },
          {
            internalType: "uint8",
            name: "critical",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "missed",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "blocked",
            type: "uint8",
          },
        ],
        internalType: "struct FightLib.AttackResult",
        name: "attackResult",
        type: "tuple",
      },
    ],
    name: "stealLife",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "int32[]",
                name: "fighterAttributes",
                type: "int32[]",
              },
              {
                components: [
                  {
                    internalType: "uint32",
                    name: "level",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "experience",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "life",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "mana",
                    type: "uint32",
                  },
                  {
                    internalType: "uint32",
                    name: "lifeChances",
                    type: "uint32",
                  },
                ],
                internalType: "struct IStatController.ChangeableStats",
                name: "fighterStats",
                type: "tuple",
              },
              {
                internalType: "enum IFightCalculator.AttackType",
                name: "attackType",
                type: "uint8",
              },
              {
                internalType: "address",
                name: "attackToken",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "attackTokenId",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "race",
                type: "uint256",
              },
            ],
            internalType: "struct IFightCalculator.FighterInfo",
            name: "info",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "enum IItemController.AttackType",
                name: "aType",
                type: "uint8",
              },
              {
                internalType: "int32",
                name: "min",
                type: "int32",
              },
              {
                internalType: "int32",
                name: "max",
                type: "int32",
              },
              {
                components: [
                  {
                    internalType: "int32",
                    name: "strength",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "dexterity",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "vitality",
                    type: "int32",
                  },
                  {
                    internalType: "int32",
                    name: "energy",
                    type: "int32",
                  },
                ],
                internalType: "struct IStatController.CoreAttributes",
                name: "attributeFactors",
                type: "tuple",
              },
            ],
            internalType: "struct IItemController.AttackInfo",
            name: "magicAttack",
            type: "tuple",
          },
          {
            internalType: "int32",
            name: "health",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "manaConsumed",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damage",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damagePoison",
            type: "int32",
          },
          {
            internalType: "int32",
            name: "damageReflect",
            type: "int32",
          },
          {
            components: [
              {
                internalType: "bool",
                name: "stun",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "burn",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "freeze",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "confuse",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "curse",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "poison",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "gotCriticalHit",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "missed",
                type: "bool",
              },
              {
                internalType: "bool",
                name: "hitBlocked",
                type: "bool",
              },
            ],
            internalType: "struct IFightCalculator.Statuses",
            name: "statuses",
            type: "tuple",
          },
        ],
        internalType: "struct IFightCalculator.Fighter",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
] as const;

export class FacadeFightLib__factory {
  static readonly abi = _abi;
  static createInterface(): FacadeFightLibInterface {
    return new Interface(_abi) as FacadeFightLibInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): FacadeFightLib {
    return new Contract(address, _abi, runner) as unknown as FacadeFightLib;
  }
}
